<div class="container">
	<div class="row init-container">
		<div class="col-md-6 col-lg-4 dashboard-title">
			<h3>Hola, {{ username }}!</h3>						
			<div>
			<blockquote cite="https://www.huxley.net/bnw/four.html">
				<p>
				{{ frase }}—{{ autor }}
				</p>
			</blockquote>			
			</div>									
			<p style="text-align: justify;">Esta plataforma est&aacute; dise&ntilde;ada para potenciar la manera de gestionar la
				documentaci&oacute;n institucional</p>
      <br>
      <button mat-fab extended routerLink="/nuevo" class="btn-new-doc">
        <mat-icon>edit_document</mat-icon>
        <span>Redactar documento</span>
      </button>
		</div>
		<div class="col-md-6 col-lg-8">
			<mat-card class="card-listado">
				<ag-charts style="height: 100%" [options]="chartOptions">
				</ag-charts>
			</mat-card>
		</div>
	
		<div class="col-md-6 col-lg-4">
			<mat-card class="card-listado">
				<mat-card-header class="card-header">
					<mat-icon mat-card-avatar>link</mat-icon>
					<mat-card-subtitle>Enlaces de inter&eacute;s</mat-card-subtitle>
				</mat-card-header>
				<mat-card-content>
					<mat-list>
						<mat-list-item>
							<mat-icon matListItemIcon>open_in_new</mat-icon>
							<span matListItemTitle>
								<a href="https://ambato.gob.ec/" target="_blank">
									GAD Municipalidad de Ambato
								</a>
							</span>
						</mat-list-item>
						<mat-list-item>
							<mat-icon matListItemIcon>open_in_new</mat-icon>
							<span matListItemTitle>
								<a href="https://www.emapa.gob.ec/" target="_blank">
									EP Emapa Ambato
								</a>
							</span>
						</mat-list-item>
						<mat-list-item>
							<mat-icon matListItemIcon>open_in_new</mat-icon>
							<span matListItemTitle>
								<a href="https://www.epmgidsa.gob.ec/">
									EPM Gidsa url Inicio
								</a>
							</span>
						</mat-list-item>
					</mat-list>
				</mat-card-content>
			</mat-card>
		</div>
		<div class="col-md-6 col-lg-8">
			<mat-card class="card-listado">
				<mat-card-header class="card-header">
					<mat-icon mat-card-avatar>gavel</mat-icon>
					<mat-card-subtitle>Marco legal vigente</mat-card-subtitle>
				</mat-card-header>
				<mat-card-content>
					<mat-list>
						<mat-list-item>
							<mat-icon matListItemIcon>open_in_new</mat-icon>
							<span matListItemTitle>
								<a href="https://web.gestiondocumental.gob.ec/wp-content/uploads/2020/08/Norma-Técnica-Ecuatoriana-NTE-INEN-2410-2013.pdf"
									target="_blank">
									Norma Técnica Ecuatoriana
									NTE INEN 2410:2013
								</a>
							</span>
						</mat-list-item>
						<mat-list-item>
							<mat-icon matListItemIcon>open_in_new</mat-icon>
							<span matListItemTitle>
								<a href="https://www.puertodemanta.gob.ec/wp-content/uploads/2016/12/6.-NORMA_DE_GESTION_DOCUMENTAL_PARA_ENTIDADES_DE_ADMINISTRACION_PUBLICA.pdf"
									target="_blank">
									Norma de gestion documental para entidades de administracion publica
								</a>
							</span>
						</mat-list-item>
						<mat-list-item>
							<mat-icon matListItemIcon>open_in_new</mat-icon>
							<span matListItemTitle>
								<a href="https://web.gestiondocumental.gob.ec/wp-content/uploads/2020/08/ley_de_comercio_electronico.pdf"
									target="_blank">
									Ley de comercio electrónico, firmas electrónicas y mensajes de datos </a>
							</span>
						</mat-list-item>
						<mat-list-item>
							<mat-icon matListItemIcon>open_in_new</mat-icon>
							<span matListItemTitle>
								<a href="https://www.gobiernoelectronico.gob.ec/normativa/" target="_blank">
									Otras normativas
								</a>
							</span>
						</mat-list-item>
					</mat-list>
				</mat-card-content>
			</mat-card>
		</div>
	</div>
</div>
